<template>

    <modal class="premium-feature-modal"  @close="$emit('close')" :show_close_button="true">
      <template v-slot:body>
        <div class="video-modal-box">
          <div class="welcome-video">
              <div class="tutorial-content" :style="`background-image:url(${bg_image})`" >
                <img loading="lazy"  v-if="show_logo" class="logo" src="@/assets/filmstro-logo.png" alt="Filmstro Logo">
                <h3>{{title}}</h3>
                <div class="modal-emoji">{{emoji}}</div>
              </div>
          </div>

          <div class="welcome-description">
            <p>Upgrade from only $14.99 to save unlimited custom sound track sessions and create favourites</p>
          </div>

          <div class="flex gap-1 modal-actions">

            <h6>
              <button @click="goToYouTuberPlan" class="btn comman-btn modal-btn">UNLOCk FOR $14.99</button>
              <span class="plan-description">
                Personal use incl. monetized YouTube
              </span>
            </h6>

            <h6>
              <button @click="goToPricing" class="btn comman-btn modal-btn">VIEW ALL PLANS</button>
            </h6>
          </div>
        </div>
      </template>
    </modal>


</template>
<script>
import {computed, ref} from 'vue'
import {useStore} from 'vuex'
import { website_url } from '@/includes/helpers';

export default {
    props:{
      show_logo:{
        default:true
      },
      title:{
        default:"This is a paid feature"
      },
      emoji:{
        default:"🤓"
      }
    },
    setup(){


        let bg_image = require( '@/assets/images/tutorial-bg.png' );
        const store = useStore();



        let closeModal = ()=>{
          this.$emit('close');
          // store.commit('setShowPremiumFeatureModal',false);
        }

        let goToYouTuberPlan = ()=>{
          let url = `${website_url()}/product/youtuber-monthly`
          try{
            window.location.href = url;
          }
          catch{
            window.open( url );
          }
        }

        let goToPricing = ()=>{
          let url = `${website_url()}/pricing`
          try{
            window.location.href = url;
            }
          catch{
            window.open( url );
          }
        }

        return {
            bg_image,
            goToPricing,
            goToYouTuberPlan,
            closeModal,
        }
    }
}
</script>

<style lang="scss">
.premium-feature-modal {

  .modal-dialog {
    background: linear-gradient(180deg, #292938, #15151C);
    border-radius: 15px;
    max-width: 100%!important;
    .modal-content{
      border-radius: inherit;
    }
  }

  .welcome-video {
      height: 220px;
  }

  .welcome-video iframe {
      width: 100%;
      height: 100%;
  }
  .video-modal-box p{
    font-size: 0.8rem;
    color: #D8D8D8;
  }

  .modal-body{
    width: 500px;
  }
  .welcome-description{
    margin-bottom: 20px;
    p{
      margin-bottom: 30px;
      margin-top: 30px;
    }
  }
  .modal-actions{
    justify-content: center;
    gap: 20px;
    display: flex;
    button{
      font-size: .8rem;
    }
  }

  .tutorial-content {
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 1.8rem;
    line-height: 2rem;
    h3 {
      color: white!important;
      font-weight: 800;
    }
    .modal-emoji{
      margin-top: 5px;
    }

  }
  img.logo {
    margin-bottom: 10px;
    width: 60px;
  }
  span.plan-description {
    display: block;
    margin-top: 5px;
    font-size: .55rem;
    color: #D8D8D8;
  }
  .btn-close{
    color: #D8D8D8!important;
    font-size: 1.5rem!important;
  }
}
</style>